import {
  DataRoomFolderBrowseFragmentFragment,
  DealRoleType,
} from "@/src/graphql/generated";
import { Checkbox } from "@/src/components/checkbox";
import { useContext } from "react";
import { DataRoomContext } from "..";
import { PermissionCheck } from "@/src/components/permissions/PermissionCheck";

interface DataRoomTableHeaderProps {
  folder?: DataRoomFolderBrowseFragmentFragment;
}

export function DataRoomTableHeader(props: DataRoomTableHeaderProps) {
  const {
    selectedFolders,
    selectedFiles,
    setSelectedFolders,
    setSelectedFiles,
    indexingEnabled,
  } = useContext(DataRoomContext);
  const totalSelectedItems = selectedFolders.length + selectedFiles.length;

  return (
    <thead>
      <tr>
        <th
          className="align-middle text-sm py-2 px-3 text-gray-500/80 items-center gap-x-2 hidden md:flex"
          style={{ width: 40 }}
        >
          <Checkbox
            indeterminate={
              totalSelectedItems > 0 &&
              totalSelectedItems <
                (props.folder?.files?.length ?? 0) +
                  (props.folder?.folders?.length ?? 0)
            }
            checked={totalSelectedItems > 0}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedFolders(
                  props.folder?.folders.map((folder) => folder.id) ?? [],
                );
                setSelectedFiles(
                  props.folder?.files.map((file) => file.id) ?? [],
                );
              } else {
                setSelectedFiles([]);
                setSelectedFolders([]);
              }
            }}
          />
        </th>
        {indexingEnabled ? (
          <th
            className="text-sm py-2 px-3 text-persian-990 truncate"
            style={{ minWidth: 50 }}
          >
            Index
          </th>
        ) : null}
        <th
          className="align-middle text-sm py-2 px-3 text-persian-990 truncate"
          style={{ width: "100%" }}
        >
          Name
        </th>
        <PermissionCheck
          input={{
            permissionKey: "documents:has_access",
            roleType: DealRoleType.Internal,
          }}
        >
          <th
            className="align-middle text-sm py-2 px-3 text-persian-990 hidden xl:table-cell truncate"
            style={{ minWidth: 140 }}
          >
            Created by
          </th>
        </PermissionCheck>
        <th
          className="align-middle text-sm py-2 px-3 text-persian-990 hidden md:table-cell truncate"
          style={{ minWidth: 130 }}
        >
          Last updated
        </th>
        <PermissionCheck
          input={{
            permissionKey: "documents:has_access",
            roleType: DealRoleType.Internal,
          }}
        >
          <th
            className="align-middle text-sm py-2 px-3 text-persian-990 hidden lg:table-cell truncate"
            style={{ minWidth: 130 }}
          >
            Access
          </th>
          <th className="py-1 px-2 w-55 text-gray-500 hidden xl:table-cell"></th>
        </PermissionCheck>
      </tr>
    </thead>
  );
}
